export enum WaitingListStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED'
}
